module.exports = __webpack_public_path__ + "img/KSC09927.a907934f.jpg";